
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const tickets = [
  { event: "Synthwave Night", venue: "The Velvet Underground", sold: "280/300", status: "Live", revenue: "$4,200" },
  { event: "Bass Drop Fridays", venue: "Neon Garden", sold: "750/800", status: "Live", revenue: "$18,750" },
  { event: "Summer Fest Day 1", venue: "The Warehouse Project", sold: "1800/2000", status: "Nearing Capacity", revenue: "$90,000" },
  { event: "Sunset Grooves", venue: "Rooftop Rhythms", sold: "150/150", status: "Sold Out", revenue: "$3,000" },
  { event: "Retro Rewind", venue: "The Velvet Underground", sold: "0/300", status: "Upcoming", revenue: "$0" },
];

const TicketManagement = () => {
  const getStatusBadge = (status: string) => {
    switch (status) {
      case "Live":
        return <Badge className="bg-green-500/20 text-green-300 border-green-500/30">{status}</Badge>;
      case "Nearing Capacity":
        return <Badge className="bg-yellow-500/20 text-yellow-300 border-yellow-500/30">{status}</Badge>;
      case "Sold Out":
        return <Badge className="bg-red-500/20 text-red-300 border-red-500/30">{status}</Badge>;
      case "Upcoming":
        return <Badge variant="secondary">{status}</Badge>;
      default:
        return <Badge>{status}</Badge>;
    }
  };

  return (
    <Card className="bg-white/5 border-white/20 text-white">
      <CardHeader>
        <CardTitle>🎟️ Ticket Management</CardTitle>
        <CardDescription className="text-gray-400">Ticket sales tracker per event/venue.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow className="border-white/20 hover:bg-white/10">
              <TableHead className="text-white">Event</TableHead>
              <TableHead className="text-white hidden md:table-cell">Venue</TableHead>
              <TableHead className="text-white hidden sm:table-cell">Tickets Sold</TableHead>
              <TableHead className="text-white">Status</TableHead>
              <TableHead className="text-white hidden lg:table-cell">Revenue</TableHead>
              <TableHead className="text-white text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {tickets.map((ticket) => (
              <TableRow key={ticket.event} className="border-white/20 hover:bg-white/10">
                <TableCell className="font-medium">{ticket.event}</TableCell>
                <TableCell className="hidden md:table-cell">{ticket.venue}</TableCell>
                <TableCell className="hidden sm:table-cell">{ticket.sold}</TableCell>
                <TableCell>{getStatusBadge(ticket.status)}</TableCell>
                <TableCell className="hidden lg:table-cell">{ticket.revenue}</TableCell>
                <TableCell className="text-right">
                    <Button variant="outline" size="sm" className="bg-transparent hover:bg-white/10 border-white/30 text-white hover:text-white">Manage</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default TicketManagement;
